export function deepCopy<T>(sourceObject: T): T {
  try {
    return JSON.parse(JSON.stringify(sourceObject)) as T
  } catch (error) {
    throw new Error(error as string | undefined)
  }
}
